import { render, staticRenderFns } from "./SubscriptionCard.vue?vue&type=template&id=033fd44e&scoped=true"
import script from "./SubscriptionCard.vue?vue&type=script&lang=ts"
export * from "./SubscriptionCard.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionCard.vue?vue&type=style&index=0&id=033fd44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033fd44e",
  null
  
)

export default component.exports